/*
 * @Author: wb_xianghongchi
 * @Date: 2023-09-04 14:55:11
 * @Email: wb_xianghongchi@meituan.com
 * @LastEditors: wb_xianghongchi
 * @LastEditTime: 2024-07-02 17:47:20
 * @Description: 
 */
import React, { PureComponent } from 'react';
import UploadFile from '@/components/upload-component/UploadFileVenus';
import { SearchImageType } from "@/utils/uploadSdk";
import MarketBatchUpload from '@/assets/images/marketBatchUpload.png';
import { Button, Progress } from "@ss/mtd-react"

export default class ImageSearch extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      file: props?.picUrl ? { fileUrl: props.picUrl, hasError: false, hasUploaded: true, percent: 0 } : null,
      materialList: [],
      percent: 0
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.picUrl !== prevProps.picUrl && this.props.picUrl === null) {
      this.setState({ file: { fileUrl: this.props.file } })
    }
  }

  addUploadFile = () => {

  }

  onSuccess = (file) => {
    this.setState({
      file,
    })
    this.props.onChange(file)
  }

  changeMaterialStatus = () => {

  }

  changeFileStatus = (file) => {
    this.setState({ file, percent: file.percent })
  }

  render() {
    const { file, percent } = this.state;
    const isUpload = file && !file.hasUploaded && !file.hasError;
    return (
      <div>
        <div className='color-search-wrap image-search-wrap'
          onClick={(e) => { e.stopPropagation() }}
        >
          <div className='title'>以图搜图</div>
          <UploadFile
            style={{ width: '100%', marginTop: 8 }}
            draggable={true}
            multiple={false}
            accept={SearchImageType.accept}
            maxSizeLimit={SearchImageType.maxSizeLimit}
            addUploadFile={this.addUploadFile}
            onSuccess={this.onSuccess}
            changeMaterialStatus={this.changeMaterialStatus}
            changeFileStatus={this.changeFileStatus}
          >
            <div className='upload-file-content-wrap'>
              <div className='upload-file-content'>
                <img src={MarketBatchUpload} loading='lazy' />

                {
                  isUpload ? <div style={{ marginTop: 10 }}>
                    <Progress percentage={percent} strokeWidth={6} style={{ width: 220 }}></Progress>
                  </div> : <div className='add-image'>
                    <span>拖拽一张图片到此区域，或</span>
                    <span>点此添加</span>
                  </div>
                }
                <span className='description'>图片格式支持 JPEG、PNG、GIF、WEBP、TIFF，最大不超过{SearchImageType.maxSizeLimit.size}{SearchImageType.maxSizeLimit.unit}</span>
              </div>
            </div>
          </UploadFile>
        </div>
      </div>
    )
  }
}

